<script>
import { mapActions } from 'vuex';
import toggleModal from '@/mixins/toggleModal';

export default {
  data() {
    return {
      isDefault: false,
      companyId: null,
    };
  },
  props: {
    companyOptions: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [toggleModal],
  methods: {
    ...mapActions({
      addRushAction: 'rushes/createRushes',
    }),
    handleOk(values) {
      this.addRushAction({
        ...values,
        isDefault: this.isDefault,
        companyId: this.companyId ?? null,
      });
      this.hideModal();
    },
  },
};
</script>

<template>
  <a-modal :open="show" :footer="null" @cancel="hideModal" >
    <FormKit
      type="form"
      submit-label="Add rush"
      @submit="handleOk"
    >
      <h1 class="text-2xl font-bold mb-2">Create new rush</h1>
      <FormKit
        type="number"
        number="integer"
        name="percent"
        label="Percentage"
        placeholder="Percentage"
        validation="required"
      />
      <div class="toggle">
        Default can rush
        <a-switch class="mb-2" v-model:checked="isDefault" ></a-switch>
      </div>
      <a-form-item label="Company" class="mb-2">
        <a-select
          v-model:value="companyId"
          :options="companyOptions"
          allow-clear
          placeholder="Select company"
          style="width: 100%"
        />
      </a-form-item>
      <FormKit
        type="text"
        name="digitize"
        label="Digitize text"
        placeholder="Digitize text"
        validation="required"
      />
      <FormKit
        type="text"
        name="enhance"
        label="Enhance text"
        placeholder="Enhance text"
        validation="required"
      />
      <FormKit
        type="text"
        name="photoArt"
        label="Photo art text"
        placeholder="Photo art text"
        validation="required"
      />
    </FormKit>
  </a-modal>
</template>

<style scoped lang="scss">
.toggle {
  margin: 20px 0;
}
</style>
